function addToCartWithNotify(id, quantity = '1', button) {
  if(!id) return;
  
  let formData = new FormData();
  formData.append('id', id);
  formData.append('quantity', quantity);

  let queryString = new URLSearchParams(formData).toString();
  //Add to cart
  $.post(theme.routes.cart_add_url + ".js", queryString, function (itemData) {


      var contentFunc = $(button).is('button') ? 'html' : 'val';
      //Set to 'DONE', alter button style, wait a few secs, revert to normal
      $(button)[contentFunc](theme.strings.addedToCart);
      setTimeout(function () {
        $(button).removeAttr('disabled')[contentFunc]($(button).data('previous-value'));
      }, 1000);

      // reload header
      $.get(theme.routes.search_url, function (data) {
        var selectors = [
          ".page-header .header-cart",
          ".docked-navigation-container .header-cart",
        ];

        var $parsed = $($.parseHTML("<div>" + data + "</div>"));
        for (var i = 0; i < selectors.length; i++) {
          var cartSummarySelector = selectors[i];
          var $newCartObj = $parsed.find(cartSummarySelector).clone();
          var $currCart = $(cartSummarySelector);
          $currCart.replaceWith($newCartObj);
        }
      });

      // display added notice
      // get full product data
      theme.productData = theme.productData || {};
      if (!theme.productData[itemData.product_id]) {
        theme.productData[itemData.product_id] = itemData;
      }
      var productVariant = itemData;

      let productLineItems = {};
      // const formData = new FormData($form[0]);
      // for (const [key, value] of formData) {
      //   if (key.indexOf("properties[") === 0 && value) {
      //     const name = key.split("[")[1].split("]")[0];
      //     if (name[0] !== "_") {
      //       productLineItems[name] = value;
      //     }
      //   }
      // }

      var productPrice = "";
      if (itemData.original_line_price > itemData.final_line_price) {
        productPrice +=
          '<span class="cart-summary__price-reduced product-price__reduced theme-money">' +
          theme.Shopify.formatMoney(
            itemData.final_line_price,
            theme.moneyFormat
          ) +
          "</span>";
        productPrice +=
          '<span class="cart-summary__price-compare product-price__compare theme-money">' +
          theme.Shopify.formatMoney(
            itemData.original_line_price,
            theme.moneyFormat
          ) +
          "</span>";
      } else {
        productPrice +=
          '<span class="theme-money">' +
          theme.Shopify.formatMoney(
            itemData.final_line_price,
            theme.moneyFormat
          ) +
          "</span>";
      }
      if (itemData.unit_price) {
        productPrice +=
          '<span class="cart-summary__unit-price unit-price theme-money">' +
          theme.Shopify.formatMoney(itemData.unit_price, theme.moneyFormat) +
          theme.strings.unitPriceSeparator +
          itemData.unit_price_measurement.reference_unit +
          "</span>";
      }

      // append quantity
      var productQty = "";
      if (itemData.quantity > 1) {
        productQty =
          ' <span class="cart-summary__quantity">' +
          itemData.quantity +
          "</span>";
      }

      // append preorder text
      var productPreorderHTML = "";
    
      // if ($form.parent()[0].hasAttribute("data-preorder")) {
      //   productPreorderHTML =
      //     ' <span class="cart-summary__preorder">' +
      //     theme.strings.productPreorder +
      //     "</span>";
      // }

      if (
        itemData.line_level_discount_allocations &&
        itemData.line_level_discount_allocations.length > 0
      ) {
        productPrice += '<ul class="cart-discount-list small-text">';
        for (
          var i = 0;
          i < itemData.line_level_discount_allocations.length;
          i++
        ) {
          var discount_allocation = itemData.line_level_discount_allocations[i];
          productPrice += [
            '<li class="cart-discount">',
            '<div class="cart-discount__label">',
            discount_allocation.discount_application.title
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;"),
            "</div>",
            '<div class="cart-discount__amount theme-money">',
            theme.Shopify.formatMoney(
              discount_allocation.amount,
              theme.moneyFormat
            ),
            "</div>",
            "</li>",
          ].join("");
        }
        productPrice += "</ul>";
      }
      var sellingPlanHTML = "";
      if (
        itemData.selling_plan_allocation &&
        itemData.selling_plan_allocation.selling_plan.name
      ) {
        sellingPlanHTML = [
          '<div class="cart-summary__selling-plan ">',
          itemData.selling_plan_allocation.selling_plan.name,
          "</div>",
        ].join("");
      }

      var productVariantsHTML = "";
      if (productVariant) {
        // get option names from full product data
        var optionNames = theme.productData[itemData.product_id].options_with_values;
        productVariantsHTML = '<div class="cart-summary__product__variants">';
        for (var i = 0; i < productVariant.options_with_values.length; i++) {
          if (productVariant.options_with_values[i].value.indexOf("Default Title") < 0) {
            productVariantsHTML += '<div class="cart-summary__variant">';
            productVariantsHTML +=
              '<span class="cart-summary__variant-label">' +
              optionNames[i].value +
              ":</span> ";
            productVariantsHTML +=
              '<span class="cart-summary__variant-value">' +
              productVariant.options_with_values[i].value +
              "</span>";
            productVariantsHTML += "</div>";
          }
        }
        productVariantsHTML += "</div>";
      }

      var productLineItemsHTML = "";
      if (Object.keys(productLineItems).length > 0) {
        productLineItemsHTML =
          '<div class="cart-summary__product__line-items">';
        const tempSpan = document.createElement("span");
        for (const key of Object.keys(productLineItems)) {
          tempSpan.innerText = productLineItems[key];
          productLineItemsHTML += `<div>${key}: ${tempSpan.innerHTML}</div>`;
        }
        productLineItemsHTML += "</div>";
      }

      var productImage;
      if (productVariant.featured_image) {
        productImage = productVariant.featured_image.url
      } else if (
        productVariant.image
      ) {
        productImage = productVariant.image
      }

      console.log(productImage);

      // additional fetch - for full cart data
      $.getJSON(theme.routes.cart_url + ".js", function (cartData) {
        var $template = $(
          [
            '<div class="added-notice global-border-radius added-notice--pre-reveal">',
            '<div class="added-notice__header">',
            '<span class="added-notice__title">',
            theme.strings.addedToCartPopupTitle,
            "</span>",
            '<a class="added-notice__close feather-icon" href="#" aria-label="',
            theme.strings.close,
            '">',
            theme.icons.close,
            "</a>",
            "</div>",
            '<div class="cart-summary global-border-radius">',
            '<div class="cart-summary__product">',
            '<div class="cart-summary__product-image"><img class="global-border-radius" src="',
            productImage,
            '" role="presentation" alt=""></div>',
            '<div class="cart-summary__product__description">',
            '<div class="cart-summary__product-title">',
            theme.productData[itemData.product_id].title,
            productQty,
            "</div>",
            productVariantsHTML,
            productLineItemsHTML,
            productPreorderHTML,
            sellingPlanHTML,
            '<div class="cart-summary__price">',
            productPrice,
            "</div>",
            "</div>",
            "</div>",
            "</div>",
            '<div class="cart-summary__footer">',
            '<div class="cart-summary__total-quantity-row">',
            "<span>",
            theme.strings.addedToCartPopupItems,
            "</span>",
            "<span>",
            cartData.item_count,
            "</span>",
            "</div>",
            '<div class="cart-summary__total-price-row large-text">',
            "<span>",
            theme.strings.addedToCartPopupSubtotal,
            "</span>",
            '<span class="theme-money">',
            theme.Shopify.formatMoney(
              cartData.total_price,
              theme.moneyFormatWithCodeForCartPreference
            ),
            "</span>",
            "</div>",
            '<a href="',
            theme.routes.cart_url,
            '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">',
            theme.strings.addedToCartPopupGoToCart,
            "</a>",
            "</div>",
            "</div>",
          ].join("")
        );
        $template.appendTo("body");

        // transition in
        setTimeout(function () {
          $template.removeClass("added-notice--pre-reveal");
        }, 10);

        // transition out
        theme.addedToCartNoticeHideTimeoutId = setTimeout(function () {
          $template.find(".added-notice__close").trigger("click");
        }, 5000);
      });
    },
    "json"
  ).fail(function (data) {
    // Enable form
    // $form.removeClass("add-in-progress");
    // var $firstBtn = $form
    //   .find(":submit")
    //   .removeAttr("disabled")
    //   .each(function () {
    //     var $btn = $(this);
    //     var contentFunc = $btn.is("button") ? "html" : "val";
    //     $btn[contentFunc]($btn.data("previous-value"));
    //   })
    //   .first();

    //Not added, show error message
    if (typeof data != "undefined" && data.responseJSON) {
      var errorMessage =
        typeof data.responseJSON.description === "string"
          ? data.responseJSON.description
          : data.responseJSON.message;
      if (
        data.responseJSON.errors &&
        typeof data.responseJSON.errors === "object"
      ) {
        errorMessage = Object.entries(data.responseJSON.errors)
          .map((item) => item[1].join(", "))
          .join("<br>");
      }
      console.log(errorMessage);
      // theme.showQuickPopup(errorMessage, $firstBtn);
    } else {
      //Some unknown error? Disable ajax and submit the old-fashioned way.
      // $form.off("submit").submit();
    }
  });
}
